import _ from 'underscore';
import Radio from 'backbone.radio';
import async from 'async';


    var globalCh = Radio.channel('global');
    var apiCh = Radio.channel('api');
    /**
        * Fetch everything. This is stupid.
        * Temporary until we can work around it; it mimics
        * what we used to do on every router nav event.
        *
        * (partially stolen from fetch_collection in ide_app.js)
        */
    function fetchEverything(cb) {
        var active_account = globalCh.request('active_account');
        var primary_account = globalCh.request('primary_account');

        var products = apiCh.request('product');

        function fetch_collection(collection, options, cb) {
            if (_.isFunction(options)) {
                cb = options;
                options = null;
            }

            if (!options) { options = {}; }
            options = _.extend({
                success: function() {
                    return cb();
                },
                error: function(coll, resp) {
                    return cb(resp);
                }
            }, options);
            collection.fetch(options);
        }

        function fetch_collection_for_account(account, collection, options, cb) {
            if (_.isFunction(options)) {
                cb = options;
                options = null;
            }

            if (!options) { options = {}; }

            options = _.extend({
                remove: false,
                data: {
                    'filter[owner.id]': account.id
                }
            }, options);

            fetch_collection(collection, options, cb);
        }

        // An object we'll use to collect the functions we want to call asynchronously
        var async_funcs = {};

        var dev_devices = {
            devices:            _.partial(fetch_collection, active_account.devices, {})
        };
        var v5_collections = {
            products:           _.partial(fetch_collection_for_account, active_account, products)
        };

        var can_fetch_dev_devices = active_account.permits(primary_account, 'view_development_devices');
        var can_fetch_products = active_account.permits(primary_account, 'view_products');

        if (can_fetch_dev_devices) { _(async_funcs).extend(dev_devices); }
        if (can_fetch_products) { _(async_funcs).extend(v5_collections); }

        async.parallel(async_funcs, function(err) {
            if (cb) {
                return cb(err);
            }
        });
    }
    export default fetchEverything;

